<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <BTabs :active-tab="active_tab">

              <BTab :title="$t('saleReport')">
                <SaleReportProductAndCustomers/>
              </BTab>
              <BTab :title="$t('customerBill')">
                <SaleReport/>
              </BTab>

              <BTab :title="$t('SaleInvoiceReports')">
                <SaleInvoiceReport/>
              </BTab>

              <BTab :title="$t('router.listCustomers')">
                <CustomerList/>
              </BTab>
              <BTab :title="$t('sidebars.listProduct')">
                <ProductList fields_data="sale"/>
              </BTab>

              <BTab v-if="get_access('hyper_sale')" title="گزارش فاکتور صادر کننده">
                <CreatorDocs />
              </BTab>

            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

import BTabs from "../../tabs/BTabs";

import CustomerList from "../sell/CustomerList";
import CustomerBill from "../sell/CustomerBill";
import SaleReport from "../reports/SaleReport";
import ProductList from "../products/ProductList";
import SaleProductsReport from "./SaleProductsReport";
import SaleInvoiceReport from "./SaleInvoiceReport";
import SaleReportProductAndCustomers from "./SaleReportProductAndCustomers";
import BTab from "../../tabs/BTab";
import CreatorDocs from "./CreatorDocs.vue";
export default {
  name: 'Login',
  components: {
    BTab,
    BTabs,
    CreatorDocs,
    SaleProductsReport,
    ProductList,
    SaleReport,
    CustomerList,
    CustomerBill,
    SaleReportProductAndCustomers,
    SaleInvoiceReport
  },
  data() {
    return {

      active_tab:0,

    }
  }, mounted() {

    // this.get_lists();
    if(this.$route.params.customer_report!=null){
      this.active_tab = 1
    }

  }, watch: {

  },
  methods: {

  }
}

</script>
